<template>
  <div class="answer">
    <div class="answer__container">
      <a href="/campaign/chart/" class="answer__header">
        <img src="../../static/header_logo.svg" alt="ティップネスキッズロゴ" class="answer__header-logo">
        <p class="answer__header-title">ティップネス・キッズ</p>
      </a>

      <div class="answer__chart-wrap">
        <p class="answer__chart-title">診断結果</p>
        <div class="answer__chart">
          <p class="answer__chart-element answer__chart-element--orange">運動習慣力<span
              class="answer__chart-point answer__chart-point--orange">{{ this.powerScores[1] }}</span></p>
          <p class="answer__chart-element answer__chart-element--green">生活習慣力<span
              class="answer__chart-point answer__chart-point--green">{{ this.powerScores[0] }}</span></p>
          <p class="answer__chart-element answer__chart-element--blue">コントロール力<span
              class="answer__chart-point answer__chart-point--blue">{{ this.powerScores[2] }}</span></p>
          <div class="answer__radar-chart-data">
            <img class="answer__graph" src="../../static/graph.svg" alt="graph">
            <rader-chart :radar-chart-data="radarChartData" :options="radarChartOptions"/>
          </div>
        </div>
        <div class="answer__advice-wrap answer__advice-wrap--green">
          <p class="answer__advice-title answer__advice-title--green">お子さまへの<br><span
              class="answer__advice-title-part">生活習慣力</span>アドバイス</p>
          <p class="answer__advice-text">{{ power1Body }}</p>
        </div>
        <div class="answer__advice-wrap answer__advice-wrap--blue">
          <p class="answer__advice-title answer__advice-title--blue">お子さまへの<br><span
              class="answer__advice-title-part">コントロール力</span>アドバイス</p>
          <p class="answer__advice-text">{{ power3Body }}</p>
        </div>
        <div class="answer__advice-wrap answer__advice-wrap--orange">
          <p class="answer__advice-title answer__advice-title--orange">お子さまへの<br><span
              class="answer__advice-title-part">運動習慣力</span>アドバイス
          </p>
          <p class="answer__advice-text">{{ power2Body }}</p>
        </div>
      </div>
    </div>

    <div class="answer__goal-wrap">
      <div class="answer__goal">
        <a href="https://kids.tipness.co.jp/search/" class="answer__goal-item" target="_blank" rel="noopener">
          <img class="goal__banner-image"
               src="../../static/test.svg"
               alt="TIPNESSキッズ">
        </a>
        <a href="https://www.instagram.com/tipness.kids/" class="answer__goal-item" target="_blank" rel="noopener">
          <img class="goal__banner-image"
               src="../../static/banner2.svg"
               alt="インスタグラム">
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import RaderChart from "./RaderChart";

export default {
  name: 'AnswerPage',
  components: {
    RaderChart
  },
  data: () => {
    return {
      powerScores: [],
      power1Bodies: [
        "朝からご飯を食べ、昼に活動し、夜に睡眠スイッチを入れることで負けないカラダが育ちます。朝は太陽の光を浴びて脳のスイッチをオンにし、その後朝ごはんを食べて臓器のスイッチもオンにしましょう！　寝る前のお手玉で、頭がリラックス！　良質な睡眠が朝の目覚めにつながります！　お役立ちコンテンツをチェック！",
        "夜寝る前にテレビをみたり、ゲームをしたりしていませんか？　寝る前に目から入る強い光は睡眠の時間や質を低下させ、成長を妨げる原因にも！　そんなお子さまはお手玉で頭のリラックス！　寝る前に行うとぐっすり寝れるかも！　負けないカラダを育てるために、寝る前の習慣を見直し、睡眠スイッチをオンしましょう！",
        "元気に活動するための生活習慣力抜群！　お友だちと遊ぶときも、勉強を頑張るときも、ティップネススクールで合格を目指すときも、負けないカラダ間違いなし！　そんなお子さまはお役立ちコンテンツで紹介している、ちょっと難しいレベルの動画にチャレンジして集中力も鍛えよう！",
      ],
      power3Bodies: [
        "負けないカラダを育てるために、外が明るい時間にカラダを動かすことが大切です。日々の運動習慣がない場合は、おうちでカラダを動かす時間を作ることからチャレンジしましょう。お役立ちコンテンツのリズム運動動画をみながら楽しく動いてみてくださいね！",
        "おうちでテレビやスマホをみたりゲームをする時間が増え、運動をする時間が減ると、どんどんカラダが動きにくくなります。まずはお役立ちコンテンツで紹介している「おうちで簡単にできるリズム運動」で動きやすいカラダを作り、運動する習慣をつけましょう！",
        "お子さまの運動習慣力は抜群です！　更にいろんな種目にチャレンジして、さまざまな可能性を見つけよう！　お役立ちコンテンツで紹介しているリズム運動にチャレンジして、いろんな種目に役立つリズム感覚を身につけよう！",
      ],
      power2Bodies: [
        "毎日の生活で怪我をせず負けないカラダでいるために自分のカラダを知り、コントロールすることが大切です。カラダの柔軟性は怪我に負けないカラダづくりの第一歩！　お役立ちコンテンツでバレエ講師が紹介する柔軟運動にチャレンジ！　姿勢改善にもなるので毎日つづけてやってみましょう！",
        "どんな動作をしてもカラダを適応させ、怪我をしない負けないカラダでいるために、バランス感覚をアップさせることは大切なポイント。転びにくく怪我に負けないカラダを作る為の足を鍛えるバランス運動をお役立ちコンテンツで紹介！　代謝もアップする動きなので保護者の方も一緒にチャレンジ！",
        "怪我をしない負けないカラダのコントロール力が抜群です！　バレエでも、他の運動でも使える楽しい動きをお役立ちコンテンツで紹介しています！　頭もすっきり元気いっぱいになるので、ぜひ挑戦！",
      ],
      radarChartData: {
        labels: ["", "", ""],
        datasets: [
          {
            data: [],
            label: "",
            backgroundColor: "rgba(255,150,0,1)",
            pointBackgroundColor: "#FF9600",
            pointBorderColor: "#FF9600",
            pointRadius: 0,
            // hitRadius: 4,
            borderColor: "",
            borderWidth: 0,
            borderCapStyle: "round",
          },
        ],
      },
      radarChartOptions: {
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false,
        scale: {
          ticks: {
            label: false,
            suggestedMin: 0,
            suggestedMax: 8,
            stepSize: 2,
            display: false,
          },
          angleLines: {
            display: false,
          },
          gridLines: {
            display: false,
          }
        },
        tooltips: {
          enabled: false,
          callbacks: {
            title(tooltipItem, data) {
              const idx = tooltipItem[0].index;
              return data.labels[idx];
            },
            label(tooltipItem, data) {
              const idx = tooltipItem.datasetIndex;
              const label = data.datasets[idx].label;
              return label + ': ' + tooltipItem.value;
            }
          }
        }
      }
    }
  },
  computed: {
    power1Body() {
      switch (this.powerScores[0]) {
        case 2:
        case 3:
          return this.power1Bodies[0]
        case 4:
        case 5:
        case 6:
          return this.power1Bodies[1]
        case 7:
        case 8:
          return this.power1Bodies[2]
      }
    },
    power2Body() {
      switch (this.powerScores[1]) {
        case 2:
        case 3:
          return this.power3Bodies[0]
        case 4:
        case 5:
        case 6:
          return this.power3Bodies[1]
        case 7:
        case 8:
          return this.power3Bodies[2]
      }
    },
    power3Body() {
      switch (this.powerScores[2]) {
        case 2:
        case 3:
          return this.power2Bodies[0]
        case 4:
        case 5:
        case 6:
          return this.power2Bodies[1]
        case 7:
        case 8:
          return this.power2Bodies[2]
      }
    },
  },
  created() {
    this.powerScores = [
      Number(this.$route.query.power1),
      Number(this.$route.query.power2),
      Number(this.$route.query.power3),
    ]
    this.radarChartData.datasets[0].data = this.powerScores
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.answer {
  max-width: 375px;
  width: 100%;
  margin: 0 auto;
  padding-top: 23px;
  background: url("../goal_bg.png") top center repeat;
  background-size: contain;
}

.answer__container {
  padding: 0 16px;
}

.answer__header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 40px;
  text-decoration: none;
  margin-top: -10px;
}

.answer__header-logo {
  width: 42px;
  height: 42px;
}

.answer__header-title {
  display: inline-block;
  margin-left: 9px;
  font-size: 22px;
  color: #1E2D73;
  letter-spacing: -2px;
}

.answer__chart-wrap {
  position: relative;
  background-color: #fff;
  border-radius: 10px 10px 0 0;
  padding: 0 16px 10px;
  margin-bottom: 96px;
}

.answer__chart-wrap::after {
  position: absolute;
  display: inline-block;
  content: "";
  background: url("../goal_text_bg_bottom.svg") top center no-repeat;
  max-width: 343px;
  width: 100%;
  height: 46px;
  bottom: -45px;
  left: 0;
}

.answer__chart-title {
  position: absolute;
  display: inline-block;
  font-size: 20px;
  width: 144px;
  padding: 15px 0;
  background-color: #FFE400;
  border-radius: 26px;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
}

.answer__chart {
  position: relative;
  max-width: 311px;
  padding-top: 99%;
  border: 2px solid #FBE44D;
  border-radius: 50%;
  left: 0;
  top: 72px;
}

.answer__radar-chart-data {
  position: absolute;
  width: 240px;
  left: 50%;
  top: 64%;
  transform: translate(-50%, -58%);
  -webkit-transform: translate(-50%, -58%);
  -moz-transform: translate(-50%, -58%);
}

.answer__graph {
  position: absolute;
  display: inline-block;
  width: 217px;
  top: 74px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 3;
  backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
}

@media screen and (max-width: 335px ) {
  .answer__radar-chart-data {
    width: 200px;
  }

  .answer__graph {
    width: 180px;
    top: 95px;
  }
}

.answer__chart-point {
  position: absolute;
  width: 34px;
  height: 34px;
  text-align: center;
  line-height: 34px;
  font-size: 24px;
  background-color: #fff;
  border-radius: 50%;
  top: -9%;
  right: 0;
}

@media screen and (max-width: 340px) {
  .answer__chart-point {
    width: 30px;
    height: 30px;
    line-height: 30px;
    font-size: 22px;
    top: -22%;
  }
}

.answer__chart-point--green {
  display: inline-block;
  border: 2px solid #48A035;
  color: #48A035;
}

.answer__chart-point--blue {
  display: inline-block;
  border: 2px solid #018CD7;
  color: #018CD7;
}

.answer__chart-point--orange {
  display: inline-block;
  border: 2px solid #F7772F;
  color: #F7772F;
}

.answer__chart-element {
  position: absolute;
  display: inline-block;
  font-size: 14px;
  background-color: #fff;
  padding: 9px 0 9px 11px;
  text-align: left;
  border-radius: 19px;
  color: #fff;
}

@media screen and (max-width: 340px) {
  .answer__chart-element {
    font-size: 12px;
    padding: 6px 0 6px 10px;
  }
}

.answer__chart-element--green {
  background-color: #48A035;
  width: 110px;
  top: 0;
  left: 50%;
  transform: translate(-50%, -58%);
  -webkit-transform: translate(-50%, -58%);
  -moz-transform: translate(-50%, -58%);
}

.answer__chart-element--blue {
  width: 138px;
  background-color: #018CD7;
  left: 0;
  bottom: 10%;
}

.answer__chart-element--orange {
  width: 111px;
  background-color: #F7772F;
  right: 0;
  bottom: 10%;
}

@media screen and (max-width: 340px) {
  .answer__chart-element--green {
    width: 95px;
  }

  .answer__chart-element--blue {
    width: 121px;
  }

  .answer__chart-element--orange {
    width: 96px;
  }
}

.answer__advice-wrap {
  position: relative;
  padding: 45px 16px 30px;
  border-radius: 10px;
  margin-bottom: 50px;
  text-align: left;
}

.answer__advice-wrap--green {
  margin-top: 134px;
  background-color: rgba(72, 160, 53, 0.2);
  border: 2px solid #48A035;
}

.answer__advice-wrap--blue {
  background-color: rgba(1, 140, 215, 0.2);
  border: 2px solid #018CD7;
}

.answer__advice-wrap--orange {
  background-color: rgba(247, 119, 47, 0.2);
  border: 2px solid #F7772F;
  margin-bottom: 0px;
}

.answer__advice-title {
  position: absolute;
  font-size: 18px;
  line-height: 1.4;
  padding: 10px 24px;
  max-width: 242px;
  width: 100%;
  color: #fff;
  border-radius: 35px;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  text-align: center;
}

@media screen and (max-width: 355px) {
  .answer__advice-title {
    max-width: 208px;
    font-size: 16px;
  }
}

.answer__advice-title--green {
  background-color: #48A035;
}

.answer__advice-title--blue {
  background-color: #018CD7;
}

.answer__advice-title--orange {
  background-color: #F7772F;
}

.answer__advice-text {
  font-size: 18px;
  line-height: 31px;
}

.answer__plan-wrap {
  padding-bottom: 20px;
}

.answer__plan-header {
  position: relative;
  display: inline-block;
  max-width: 343px;
  width: 100%;
  margin-bottom: 16px;
  padding: 7px 0;
  background-color: #FFF148;
  font-size: 17px;
  line-height: 31px;
  border-radius: 41px;
}

@media screen and (max-width: 340px) {
  .answer__plan-header {
    font-size: 15px;
  }
}

.answer__plan-header::after {
  position: absolute;
  display: inline-block;
  content: "";
  max-width: 93px;
  width: 100%;
  height: 112px;
  background: url("../goal_button_man.svg") top no-repeat;
  top: -112px;
  right: 20px;
}

.answer__plan-item {
  background-color: #fff;
  border-radius: 27px 27px 10px 10px;
  margin-bottom: 10px;
}

.answer__plan-item--green {
  border: 2px solid #48A035;
}

.answer__plan-item--blue {
  border: 2px solid #018CD7;
}

.answer__plan-item--orange {
  border: 2px solid #F7772F;
}

.answer__plan-title {
  position: relative;
  display: inline-block;
  width: 100%;
  padding: 16px 0;
  font-size: 18px;
  color: #fff;
  border-radius: 22px;
}

@media screen and (max-width: 335px) {
  .answer__plan-title {
    font-size: 15px;
  }
}

.answer__plan-title::before {
  position: absolute;
  display: inline-block;
  content: "";
  width: 16px;
  height: 16px;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 50%);
  -webkit-transform: translate(-50%, 50%);
  -moz-transform: translate(-50%, 50%);
}

.answer__plan-title--green::before {
  background: url("../arrow_green.svg") top center no-repeat;
}

.answer__plan-title--blue::before {
  background: url("../arrow_blue.svg") top center no-repeat;
}

.answer__plan-title--orange::before {
  background: url("../arrow_orange.svg") top center no-repeat;
}

.answer__plan-title--green {
  background-color: #48A035;
}

.answer__plan-title--blue {
  background-color: #018CD7;
}

.answer__plan-title--orange {
  background-color: #F7772F;
}

.answer__plan-link-list {
  padding: 6px 0 18px;
}

.answer__plan-link {
  display: inline-block;
  width: 100%;
  font-size: 24px;
  line-height: 24px;
  text-decoration: none;
  color: #1B1C3B;
}

.answer__movie-link-label {
  margin: 17px 0 22px;
}

.answer__movie-icon {
  width: 36px;
  height: 36px;
}

.answer__goal {
  display: flex;
  max-width: 375px;
  width: 100%;
  max-height: 192px;
  background-color: #FFF148;
}

.answer__goal-item {
  display: inline-block;
  width: 50%;
}

.answer__goal-item:hover {
  opacity: .8;
}

.goal__banner-image {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/AnswerPage.vue